// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const FilterUnlock = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 19}
    height={size ?? 19}
    fill="none"
    viewBox="0 0 19 19"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.5 4A2.5 2.5 0 0 1 16 6.5V7h-1v-.5a1.5 1.5 0 0 0-3 0V9h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h5V6.5A2.5 2.5 0 0 1 13.5 4"
    />
  </svg>
);
const ForwardRef = forwardRef(FilterUnlock);
export default ForwardRef;
